var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"days_traveller_week"},_vm._l((_vm.daysList),function(day){return _c('DayItem',{key:day.number,attrs:{"day":day},nativeOn:{"click":function($event){return _vm.goToDate.apply(null, arguments)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }